import { render, staticRenderFns } from "./newpage.vue?vue&type=template&id=7d07f4d1&scoped=true"
var script = {}
import style0 from "./newpage.vue?vue&type=style&index=0&id=7d07f4d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d07f4d1",
  null
  
)

export default component.exports